import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/hanken-grotesk/latin-400.css';
import '@fontsource/hanken-grotesk/latin-500.css';
import '@fontsource/hanken-grotesk/latin-600.css';
import '@fontsource/hanken-grotesk/latin-700.css';
import '@fontsource/hanken-grotesk/latin-400-italic.css';
import { prepareFonts } from './prepareFonts';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
prepareFonts().then(() => root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
));

reportWebVitals();
